<template>
    <div class="NumbershapeTable">
        <div class="grid">
            <div v-for="{ number, label } of items" :key="number" class="Item">
                <div class="Numbershape">
                    <AnimatedNumbershape :number="number" play />
                </div>
                <div class="caption">
                    {{ label }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AnimatedNumbershape from '@/components/AnimatedNumbershape';
import itemsRaw from '@/modules/system-single/items-data';

export default {
    components: { AnimatedNumbershape },
    inject: ['theme'],
    computed: {
        items() {
            const language = this.$store.getters['moduleApp/locale'];
            return itemsRaw[language].slice(1).map(([number, label]) => {
                return {
                    number,
                    label
                };
            });
        }
    }
};
</script>

<style lang="scss" scoped>
$itemSize: 6em;

.NumbershapeTable {
    font-size: var(--app-font-size);
}
.grid {
    display: flex;
    flex-wrap: wrap;
    // max-width: ($itemSize + 2em) * 2;
    justify-content: center;
    margin: auto;
}
.Item {
    margin: 1em;
    width: $itemSize;
}
.Numbershape {
    width: $itemSize;
    height: $itemSize;
    background-color: #cf842614; //#10144f14;
    // margin-bottom: 2em;
    border-radius: 0.5em;
}
.AnimatedNumbershape {
    $size: 5em;
    width: $itemSize;
    height: $itemSize;
}
.caption {
    margin-top: 0.3em;
    text-align: center;
}
</style>
